/**
 * Vínculos de una entrevista con los sistemas donde vive el cliente.
 *
 * `GET /api/interviews` **no trae sobre `links`**: el payload de entrevistas no
 * conoce el `close_lead_id` de la cuenta. Así que el lead en Close se saca del
 * sobre `links` de `/api/clients`, que sí lo arma el servidor con la regla
 * completa (id ausente ⇒ `null`, nunca una URL a medias).
 *
 * Consecuencia deliberada: el link a Close depende de una segunda consulta.
 * Mientras no resolvió, la celda no muestra "sin vincular" — sería mentir: no
 * sabemos todavía si está vinculado. Muestra que está cargando, y si la
 * consulta falla dice que el vínculo no se pudo leer, con el mensaje de la API.
 */
import type { DeepLinkPayload } from '@ops/contracts'

import { mensajeDeError } from '../../lib/api'
import { useClients } from '../../lib/queries'

export type EstadoVinculos = 'cargando' | 'listo' | 'error'

export interface Vinculos {
  estado: EstadoVinculos
  /** Mensaje de la API cuando la consulta de clientes falló. */
  mensajeError: string | null
  /** Lead en Close de una cuenta. `null` = sin vincular. */
  closeDe: (clientId: string) => DeepLinkPayload | null
}

export function useVinculos(periodo: string): Vinculos {
  const { data, isPending, error } = useClients(periodo)

  const estado: EstadoVinculos =
    error !== null ? 'error' : isPending ? 'cargando' : 'listo'

  return {
    estado,
    mensajeError: error === null ? null : mensajeDeError(error),
    closeDe: (clientId) => data?.links.clientes[clientId]?.close ?? null,
  }
}

/*
 * La ruta interna de la ficha **no** se arma acá: vive en `lib/rutas.ts`, junto
 * al patrón que declara el router. Estaba duplicada en este archivo y en tres
 * componentes del módulo, y el router no la declaraba: los links caían en la
 * 404. Un solo constructor evita que vuelva a pasar.
 */
